import { PatientResourcesProvider } from '@/providers/PatientResourcesProvider';
import { useAccessPolicyContext } from '@/providers/useAccessPolicyContext';
import { usePatientResources } from '@/providers/usePatientResources';
import { Center, Loader } from '@mantine/core';
import { OperationOutcomeAlert } from '@medplum/react';
import { PatientDemographics } from '../ainigma/patient/demographics-actions/PatientDemographics';
import { PatientPageContent } from './PatientPageContent';
import { isOk } from '@medplum/core';

const PatientPageInternal = (): JSX.Element => {
  const { patient, outcome, handlePatientUpdate } = usePatientResources();
  const { componentAccess } = useAccessPolicyContext();

  if (outcome && !isOk(outcome)) {
    return <OperationOutcomeAlert outcome={outcome} />;
  }

  if (!patient) {
    return (
      <Center p="xl" w="100%" h="100%">
        <Loader />
      </Center>
    );
  }

  if (!componentAccess.canManageEncounters || !componentAccess.canAssignTasks) {
    return (
      <PatientDemographics
        patient={patient}
        onPatientUpdate={handlePatientUpdate}
      />
    );
  }
  return (
    <PatientPageContent
      patient={patient}
      onPatientUpdate={handlePatientUpdate}
    />
  );
};

export const PatientPage = (): JSX.Element => {
  return (
    <PatientResourcesProvider>
      <PatientPageInternal />
    </PatientResourcesProvider>
  );
};
